/*
* Copyright (c) 2023 Eugenio Espinoza
*/

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Respect in-page anchor links (e.g. "/#latest-release") — let the browser scroll to the anchor.
    if (hash) return;
    // Temporarily disable CSS smooth-scroll so page nav is an instant jump, not an animated sweep.
    const html = document.documentElement;
    const previous = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    requestAnimationFrame(() => { html.style.scrollBehavior = previous; });
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
